export const NavBarMsgs = {
  'en-US': {
    oper: 'Operations',
    acc: 'Accounts',
    reports: 'Reports',
    settings: 'Settings',
  },
  'pt-BR': {
    oper: 'Operações',
    acc: 'Contas',
    reports: 'Relatórios',
    settings: 'Configurações',
  },
};
export const LoginMsgs = {
  'en-US': {
    login: 'Login',
    email: 'E-mail: ',
    pw: 'Password: ',
    signUp: 'Sign Up',
    name: 'Name: ',
    cpw: 'Confirm Password: ',
  },
  'pt-BR': {
    login: 'Entrar',
    email: 'E-mail: ',
    pw: 'Senha:',
    signUp: 'Cadastre-se',
    name: 'Nome: ',
    cpw: 'Confirme a senha: ',
  },
};
export const SettingsMsgs = {
  'en-US': {
    title: 'Settings',
    logOutBut: 'Log Out',
    changePW: 'Change Password:',
    newPW: 'New Password:',
    confirmNewPW: 'Confirm New Password:',
    saveChanges: 'Save Changes',
    defAcc: 'Default Accounts:',
    incomes: 'Incomes:',
    expenses: 'Expenses:',
    paymentOptions: 'Payment Options:',
    maxInstallments: 'Maximum installments:',
    saveSettingsError: 'Unable to save settings. Please try again.',
    paymOptAtSight: 'At Sight:',
    paymOptToPay: 'To Pay:',
    paymOptToRec: 'To Receive:',
    transfAcc: 'Transference Accounts:',
    transFromAc: 'From:',
    transToAc: 'To:',
  },
  'pt-BR': {
    title: 'Configurações',
    logOutBut: 'Sair',
    changePW: 'Alterar Senha:',
    newPW: 'Nova Senha:',
    confirmNewPW: 'Confirme a nova senha:',
    saveChanges: 'Salvar alterações',
    defAcc: 'Contas Padrão:',
    incomes: 'Entradas:',
    expenses: 'Gastos:',
    paymentOptions: 'Opções de Pagamento:',
    maxInstallments: 'Máximo de parcelas:',
    saveSettingsError: 'Não foi possível salvar as configurações. Tente novamente.',
    paymOptAtSight: 'A Vista:',
    paymOptToPay: 'A Pagar:',
    paymOptToRec: 'A Receber:',
    transfAcc: 'Contas Padrão em Transferências',
    transFromAc: 'Conta de Origem:',
    transToAc: 'Conta de Destino:',
  },
};
export const OperMsgs = {
  'en-US': {
    title: 'Operations',
    operType: 'Type:',
    optAtSight: 'At Sight',
    optFuture: 'Future Operation',
    optComp: 'Complex Operation',
    optInternational: 'International Operation',
    optPayRecBill: 'Pay or Receive Bill',
    optTransf: 'Transference',
    emitDate: 'Emit date: ',
    expOrInc: 'Expense or Income:',
    expense: 'Expense',
    income: 'Income',
    expenses: 'Expenses:',
    incomes: 'Incomes:',
    currAc: 'Current Account:',
    whatAc: 'What Account:',
    whereAc: 'Payment Option:',
    value: 'Value: ',
    desc: 'Description:',
    notes: 'Notes:',
    regBut: 'Register',
    editBut: 'Edit',
    deleteBut: 'Delete',
    paymentOptions: 'Payment Options:',
    paymOptAtSight: 'At Sight:',
    optToPay: 'To Pay',
    paymOptToPay: 'To Pay:',
    optToRec: 'To Receive:',
    paymOptToRec: 'To Receive:',
    installments: 'Installments: ',
    date: 'Date: ',
    dueDate: 'Due Date: ',
    payDate: 'Payment Date: ',
    transfDate: 'Transference Date:: ',
    addAcBut: 'Add Account',
    addPaymBut: 'Add Payment',
    total: 'Total: ',
    howPaym: 'How was the payment?',
    diff: 'Diff:',
    payA: 'Pay!',
    receiveA: 'Receive!',
    confirmA: 'Confirm!',
    transfA: 'Transfer!',
    returnlist: 'Return to List',
    toPayOrToReceive: 'To Pay or To Receive:',
    transFromAc: 'From:',
    transToAc: 'To:',
    detailBills: 'Detail bills',
  },
  'pt-BR': {
    title: 'Operações',
    operType: 'Tipo:',
    optAtSight: 'A Vista',
    optFuture: 'Operação Futura',
    optComp: 'Operação Complexa',
    optInternational: 'Operação Internacional',
    optPayRecBill: 'Pagar ou Receber Conta',
    optTransf: 'Transferência',
    emitDate: 'Data de Emissão: ',
    expOrInc: 'Gasto ou Entrada:',
    expense: 'Gasto',
    income: 'Entrada',
    expenses: 'Gastos:',
    incomes: 'Entradas:',
    currAc: 'Conta Corrente:',
    whatAc: 'Qual conta:',
    whereAc: 'Opção de Pagamento:',
    value: 'Valor: ',
    desc: 'Descrição:',
    notes: 'Obs:',
    regBut: 'Registrar',
    editBut: 'Editar',
    deleteBut: 'Deletar',
    paymentOptions: 'Opções de Pagamento:',
    paymOptAtSight: 'A Vista:',
    optToPay: 'A Pagar',
    paymOptToPay: 'A Pagar:',
    optToRec: 'A Receber',
    paymOptToRec: 'A Receber:',
    installments: 'Parcelas: ',
    date: 'Data: ',
    dueDate: 'Vencimento: ',
    payDate: 'Data do Pagamento: ',
    transfDate: 'Data da Transferência: ',
    addAcBut: 'Adicionar Conta',
    addPaymBut: 'Adicionar Pagamento',
    total: 'Total: ',
    howPaym: 'Como foi o pagamento?',
    diff: 'Dif:',
    payA: 'Pagar!',
    receiveA: 'Receber!',
    confirmA: 'Confirmar!',
    transfA: 'Transferir!',
    returnlist: 'Voltar para a lista',
    toPayOrToReceive: 'A Pagar ou A Receber:',
    transFromAc: 'Conta de Origem:',
    transToAc: 'Conta de Destino:',
    detailBills: 'Detalhar Contas',
  },
};
export const AccMsgs = {
  'en-US': {
    title: 'Accounts',
    butMsgWarningDeleteAc: 'Delete',
    titleWarningDeleteAc: 'Are You Sure?',
    initWarningDeleteAc: 'Are you sure you want to delete the ',
    endWarningDeleteAc: ' account and all its children?',
    endWarningDeleteFiAc: ' account?',
    editing: 'Editing:',
    adding: 'Adding:',
    add: 'Add',
    addA: 'Add!',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    acceptVal: 'Accept Value',
    name: 'Name',
  },
  'pt-BR': {
    title: 'Contas',
    butMsgWarningDeleteAc: 'Excluir',
    titleWarningDeleteAc: 'Tem certeza?',
    initWarningDeleteAc: 'Tem certeza que deseja excluir a conta ',
    endWarningDeleteAc: ' e todas contas ligadas a ela?',
    endWarningDeleteFiAc: '?',
    editing: 'Editando:',
    adding: 'Adicionando:',
    add: 'Adicionar',
    addA: 'Adicionar!',
    edit: 'Editar',
    delete: 'Excluir',
    cancel: 'Cancelar',
    acceptVal: 'Aceitar Valor',
    name: 'Nome',
  },
};
export const RepMsgs = {
  'en-US': {
    title: 'Reports',
    statements: 'Statements',
    incomesExpenses: 'Incomes / Expenses',
    expenses: 'Expenses',
    incomes: 'Incomes',
    future: 'Future',
    toPay: 'To Pay',
    toReceive: 'To Receive',
    general: 'General',
    statemTitle: 'Current Accounts Statements',
    initial: 'Initial: ',
    final: 'Final: ',
    thType: 'Type',
    date: 'Date',
    thAcc: 'Account',
    value: 'Value',
    balance: 'Balance',
    balanceP: 'Balance:',
    total: 'Total',
    where: 'Where',
    due: 'Due',
    transference: 'Transference',
    payment: 'Payment',
    cashFlow: 'Cash Flow',
    incomeAtSight: 'Income at sight',
    expensesAtSight: 'Expenses at sight',
    payments: 'Payments',
    transferences: 'Transfers',
    initialBalance: 'Initial Balance',
    finalBalance: 'Final Balance',
  },
  'pt-BR': {
    title: 'Relatórios',
    statements: 'Extratos',
    incomesExpenses: 'Entradas / Gastos',
    expenses: 'Gastos',
    incomes: 'Entradas',
    future: 'Futuro',
    toPay: 'A Pagar',
    toReceive: 'A Receber',
    general: 'Geral',
    statemTitle: 'Extrato de Contas Correntes',
    initial: 'Inicial: ',
    final: 'Final: ',
    thType: 'Tipo',
    date: 'Data',
    thAcc: 'Conta',
    value: 'Valor',
    balance: 'Saldo',
    balanceP: 'Saldo:',
    total: 'Total',
    where: 'Onde',
    due: 'Vence',
    transference: 'Transferência',
    payment: 'Pagamento',
    cashFlow: 'Fluxo de Caixa',
    incomeAtSight: 'Entradas a vista',
    expensesAtSight: 'Despesas a vista',
    payments: 'Pagamentos',
    transferences: 'Transferências',
    initialBalance: 'Saldo Inicial',
    finalBalance: 'Saldo Final',
  },
};
